<ng-container *ngIf="status === 'completed'; else loadingOrErrorIcon">
  <!-- Completed Status Indicator -->
  <span [ngClass]="['relative', 'inline-flex', 'rounded-full', size, 'bg-[#dfe0ff]']"></span>
</ng-container>

<ng-template #loadingOrErrorIcon>
  <ng-container *ngIf="status === 'loading'; else errorIcon">
    <!-- Loading Status Indicator -->
    <span [ngClass]="['relative', 'flex', 'items-center', size]">
      <span [ngClass]="['animate-ping', 'absolute', 'inline-flex', 'rounded-full', size, 'bg-' + color, 'opacity-75']"></span>
      <span [ngClass]="['relative', 'inline-flex', 'rounded-full', size, 'bg-' + color]"></span>
    </span>
  </ng-container>
</ng-template>

<ng-template #errorIcon>
  <!-- Error Status Indicator -->
  <span [ngClass]="['relative', 'inline-flex', 'rounded-full', size, 'bg-red-500']"></span>
</ng-template>

<div class="hidden bg-blue-sky"></div>
